<div class="container-title">
    <p>Historias de éxito</p>
</div>
<div class="container-tutorials">
  <iframe style="width: 55vw; height: 45vh;" title="youtube-video-0" [src]="this.links[5]" loading="lazy" allowfullscreen></iframe>
</div>
<div class="container-subtitle">Testimonios</div>
<div class="container-videos">
  <div class="container-videos-scroll">
    <iframe *ngFor="let link of links; let i = index" title="youtube-video-{{i + 1}}" loading="lazy" [src]="link" allowfullscreen></iframe>
  </div>
</div>